import { render, staticRenderFns } from "./_offers-by-product.componentV2.vue?vue&type=template&id=dd0303fe&scoped=true"
import script from "./_offers-by-product.componentV2.vue?vue&type=script&lang=js"
export * from "./_offers-by-product.componentV2.vue?vue&type=script&lang=js"
import style0 from "./_offers-by-product.componentV2.vue?vue&type=style&index=0&id=dd0303fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0303fe",
  null
  
)

export default component.exports